module.exports = __webpack_public_path__ + "assets/img/26_869_big.07821608.jpg";